export default __webpack_public_path__ + "static/media/img_placeholder.0ef45b40.png";